import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=7fd8e6bf"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=7fd8e6bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports